@if (exceeds()) {
  <p-tag
    severity="warn"
    class="cursor-pointer"
    role="button"
    tabindex="0"
    [pTooltip]="tooltip()"
    tooltipStyleClass="whitespace-pre-line"
    (click)="open($event)"
    (keydown.enter)="open($event)"
  >
    <i class="pi pi-exclamation-triangle mr-1"></i>{{ 'ApDocument_ReceivedShortfall' | translateWF: 'Exceeds received' }}
  </p-tag>
}
